import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material'
import { Close } from '@mui/icons-material'

type InsuranceAnnouncementDialogProps = DialogProps & {
  onClose: () => void
  onConfirm: () => void
}

const bodyTextSx = { fontSize: { xs: '14px', md: '16px' } }

const INSURANCE_PRODUCTS = [
  'Seguro de Responsabilidade Civil para Médicos',
  'Seguro Residencial',
  'Seguro de Vida',
  'Seguro Viagem',
  'Equipamentos Portáteis',
  'Seguro Auto',
]

export function InsuranceAnnouncementDialog({
  onClose,
  onConfirm,
  ...dialogProps
}: InsuranceAnnouncementDialogProps) {
  return (
    <Dialog {...dialogProps} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          pr: 6,
          position: 'relative',
        }}
      >
        <Box sx={{ fontSize: '24px' }}>🛡️</Box>
        Novidade: Seguros no seu app
        <IconButton
          aria-label="Fechar"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={1}>
          <Typography variant="body2" sx={bodyTextSx}>
            Agora você protege o que importa sem sair do app.
          </Typography>
          <Typography variant="body2" sx={bodyTextSx}>
            Na nova aba Seguros, você encontra:
          </Typography>
          <Box
            component="ul"
            sx={{
              listStyle: 'inside',
              pl: 1,
              m: 0,
              '& li': bodyTextSx,
            }}
          >
            {INSURANCE_PRODUCTS.map((product) => (
              <li key={product}>{product}</li>
            ))}
          </Box>
          <Typography variant="body2" sx={bodyTextSx}>
            Solicitação 100% online, com a segurança da Porto Seguro.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onConfirm}>
          Conhecer Seguros
        </Button>
      </DialogActions>
    </Dialog>
  )
}
